import styled from 'styled-components';

import { BasicParagraph } from '../../../foundations/typefaces/BasicParagraph';
import { BiggerSubtitle } from '../../../foundations/typefaces/BiggerSubtitle';
import { Button } from '../../buttons/Button/Button';

export const StyledButton = styled(Button)({
  ':focus-visible': {
    outline: 'auto -webkit-focus-ring-color',
  },
});

export const StyledHeader = styled(BiggerSubtitle)(({ theme: { size } }) => ({
  textAlign: 'center',
  paddingBottom: size.units(2),
}));

export const ContentWrapper = styled.div(({ theme: { size } }) => ({
  width: '100%',
  paddingBottom: size.units(2),
}));

export const StyledBasicParagraph = styled(BasicParagraph)(({ theme: { size } }) => ({
  textAlign: 'center',
  paddingBottom: size.units(2),
}));

export const StyledImage = styled.img(({ theme: { borderRadius } }) => ({
  width: '100%',
  borderRadius: borderRadius.small,
}));

export const FooterWrapper = styled.div(({ theme: { size } }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  paddingTop: size.units(2),
}));
